import React from 'react'
import styles from './styles.module.css'
import Transition from 'react-transition-group/Transition'
import ClickOutside from 'react-click-outside'
import CloseIcon from 'react-icons/lib/md/close'
import PageMeta from './PageMeta'
import useKeyboardEvent from '@hooks/useKeyboardEvent'
import Inner from './Inner'
import SuspenseLoading from '@components/SuspenseLoading'
import useDisableScroll from '@hooks/useDisableScroll'
import Loading from '@components/Loading'
import ReactDOM from 'react-dom'
import NoSSR from '@components/NoSSR'

function SelectProduct(props) {
  const {product, close: closeModal, open} = props

  const handleClose = () => {
    if (!open) return
    closeModal()
  }

  useKeyboardEvent('escape', () => {
    handleClose()
  })

  useDisableScroll(open)

  const content = (
    <div>
      {open ? (
        <style jsx global>{`
          body {
            overflow: hidden;
          }
        `}</style>
      ) : null}
      <Transition in={open} timeout={350}>
        {state => (
          <div className={styles.container + ' ' + styles['container_' + state]}>
            <ClickOutside
              onClickOutside={handleClose}
              className={styles.dialog + ' ' + styles['dialog_' + state]}>
              {state === 'exited' ? null : (
                <>
                  <div className={styles.close} onClick={handleClose}>
                    <CloseIcon size={20} />
                  </div>
                  {product ? (
                    <>
                      <SuspenseLoading>
                        <Inner {...props} />
                      </SuspenseLoading>
                      {/* when PageMeta gets rendered outside of the main Order
                      page it freezes de app. Needs more investigation. I think
                      there is an infinite loop somewhere. */}
                      <PageMeta product={product} />
                    </>
                  ) : (
                    <div className={styles.center}>
                      <Loading />
                    </div>
                  )}
                </>
              )}
            </ClickOutside>
          </div>
        )}
      </Transition>
    </div>
  )

  return ReactDOM.createPortal(content, document.querySelector('#modal-root'))
}

export default function WrappedSelectProduct(props) {
  return (
    <NoSSR>
      <SelectProduct {...props} />
    </NoSSR>
  )
}
